module.exports = __webpack_public_path__ + "static/media/play.e4e79b45.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Editor/images/play.svg
// module id = 910
// module chunks = 0